/**
 *
 * @param pathname with extension and parameters
 * @returns the path without extension selectors and parameters
 */
export function removeExtension(pathname: string) {
    const matchSelectors = pathname.match(/([^.]+)\./);
    if (matchSelectors && matchSelectors.length >= 1) {
        pathname = matchSelectors[1];
    }
    return pathname;
}
